module.exports = __webpack_public_path__ + "static/media/MZ.194731fc.png";